import { SERVICES } from './services/index';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { PageComponent } from './components/page/page.component';
import { FormsRoutingModule } from './forms-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { SummaryComponent } from './components/summary/summary.component';
import { ValueInterpolatePipe } from './pipes/value-interpolate.pipe';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AlertIconComponent } from './components/icons/alert-icon/alert-icon.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { SharedModule } from '../shared/shared.module';
import { ngfModule } from 'angular-file';
import { FormViewerModule } from '@xilo-mono/form-viewer';
import { FormContractModule, ToastService } from '@xilo-mono/form-contracts';
import { SummaryItemComponent } from './components/summary-item/summary-item.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MobileFooterNavigationComponent } from './components/mobile-footer/mobile-footer-navigation.component';
import { SoftRateComponent } from './components/soft-rate/soft-rate.component';
import { LoadingComponent } from './components/soft-rate/loading/loading.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HardRateComponent } from './components/hard-rate/hard-rate.component';
import { BookCallComponent } from './components/hard-rate/book-call/book-call.component';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonUiModule } from '@xilo-mono/common/ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ThousandsPipe } from './pipes/thousands.pipe';
import { CoverageIconComponent } from './components/coverage-icon/coverage-icon.component';
import { RepeatTitlePipe } from '@xilo-mono/form-viewer';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [
    PageComponent,
    SummaryComponent,
    ValueInterpolatePipe,
    AlertIconComponent,
    ErrorMessageComponent,
    SummaryItemComponent,
    MobileFooterNavigationComponent,
    SoftRateComponent,
    LoadingComponent,
    HardRateComponent,
    BookCallComponent,
    ThousandsPipe,
    CoverageIconComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsRoutingModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxMaskModule.forRoot(options),
    GooglePlaceModule,
    NgSelectModule,
    ngfModule,
    FormContractModule,
    FormViewerModule,
    MatSidenavModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    CommonUiModule,
    FontAwesomeModule
  ],
  providers: [...SERVICES, DatePipe, RepeatTitlePipe, ToastService]
})
export class FormModule {}
